module.exports = __webpack_public_path__ + "static/img/charm_level_98.0158de0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/level/charm_level_98.png
// module id = Nh9x
// module chunks = 0